import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalizedString } from "@amzn/aws-marketing-identity-kit-localizations";
import Button from "../base/Button";
import ClickableText from "../base/ClickableText";
import Modal from "../modal/Modal";
import { useFormStore } from "../store/formStore";
import { Sanitize } from "../Sanitize";
const sectionNames = {
    community: "Community information",
    interests: "Interest & background information",
    user: "User information",
    work: "Workplace information",
    emails: "Emails",
};
const BlockingModal = () => {
    const { isBlockingModalOpen, setBlockingModalOpen, editingSection, setEditingSection, setHasChanges, pendingSection, setPendingSection, resetFunction, setShouldSave, } = useFormStore();
    const { t } = useLocalizedString();
    const currentSectionName = editingSection ? sectionNames[editingSection] : "";
    const handleCancel = () => {
        if (resetFunction) {
            resetFunction();
        }
        setBlockingModalOpen(false);
        setHasChanges(false);
        setEditingSection(pendingSection);
        setPendingSection(null);
    };
    const handleSave = () => {
        setShouldSave(editingSection);
        setBlockingModalOpen(false);
    };
    return (_jsxs(Modal, { isOpen: isBlockingModalOpen, onClose: () => setBlockingModalOpen(false), children: [_jsx("h2", { className: "text-2xl font-bold mb-4", children: t("Unsaved changes") }), _jsx("p", { className: "text-normal", children: _jsx(Sanitize, { html: t('There are unsaved changes in the <a href="#">{{profile}}</a> section. Would you like to save or discard?', {
                        profile: t(currentSectionName),
                        interpolation: { escapeValue: false },
                    }) }) }), _jsx("div", { className: "w-full flex justify-end items-center mt-10", children: _jsxs("div", { className: "flex items-center gap-8", children: [_jsx(ClickableText, { "data-testid": "cancelButton", onClick: handleCancel, children: t("Cancel") }), _jsx(Button, { "data-testid": "saveButton", variant: "primary", onClick: handleSave, children: t("Save") })] }) })] }));
};
export default BlockingModal;
//# sourceMappingURL=BlockingModal.js.map